export default __webpack_public_path__ + "static/05-25e96a9ec72dbd0bb0fd8893b58d69fa.jpg";